import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { setAccessToken } from '../auth/token';

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [authenticated, setAuthenticated] = React.useState(null);

  useEffect(() => {
    oktaAuth.isAuthenticated().then((isAuthenticated) => {
      setAuthenticated(isAuthenticated);
      if (isAuthenticated) {
        setAccessToken(oktaAuth.getIdToken());
      } else {
        oktaAuth.signInWithRedirect();
      }
    });
  }, [oktaAuth]);

  if (!authState) return null;

  return oktaAuth && authenticated ?
    <Redirect to={{ pathname: '/' }}/> : 'Authenticating...';
};

export default Login;
